<silent-box ref="silentboxRef" :gallery="items" :visible="visible"></silent-box><slot :open-lightbox="openImg"></slot>